import { Component, Input, OnInit } from '@angular/core';
import { Breadcrumbs } from '../../../core/types/interfaces';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  imports: [CommonModule],
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs: Breadcrumbs[] = [];
  constructor(private router: Router) {}

  redirect(path: string, params: { [key: string]: string }) {
    if (!path) {
      return;
    }
    this.router.navigate([path], {
      queryParamsHandling: 'merge',
      queryParams: { ...params },
    });
  }
}
